<template>
    <div
        class="separator"
    >
        <!-- {{layout}} -->
        <div class="caption">
            <div class="text" v-html="layout.description"/>
        </div>
        <div
            class="baseline"
        >
            <div
                class="text"
                :style="{
                    backgroundImage: `url(${layout.image.url})`
                }"
            >
                <img
                    :src="layout.image.url"
                    :alt="layout.image.alt"
                    :title="layout.image.title"
                    class="seo-image"
                />
                <h3 class="baseline-text" v-html="layout.baseline"/>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.separator
    display: flex
    padding-top: 24em
    margin-top: 10%
    margin-bottom: 10%
    @include media-breakpoint-down($lg)
        flex-direction: column-reverse
    @media print
        margin-top: 1.2cm
        margin-bottom: 1.2cm
        padding-top: 0em
.caption
    margin-left: 0
    background-color: #ff2b2a

    padding-bottom: 14%
    padding-top: 11%
    width: 50%
    margin-right: -12%
    padding-right: 12%
    padding-left: 9.6%
    box-sizing: content-box
    @include media-breakpoint-down($lg)
        width: 100%
        margin-right: 0%
        padding-right: 9.6%
        box-sizing: border-box
    @media print
        padding-bottom: 0%
        padding-top: 0%
        width: auto
    /deep/ h1,
    /deep/ h2,
    /deep/ h3,
    /deep/ h4,
    /deep/ p
        color: #ffffff !important
    .text
        padding-right: 10.41667% * .875
        max-width: 38em
        margin-left: auto
        @include media-breakpoint-down($lg)
            padding-right: 0
            max-width: initial
            margin-left: 0
.baseline
    width: 50%
    margin-top: -24em
    position: relative
    @include media-breakpoint-down($lg)
        width: 100%
    @media print
        margin-top: 0
    .text
        width: auto
        padding-top: 14%
        padding-left: 16%
        padding-right: 9.6%
        min-height: 100vh
        background-position: 50% 0%
        background-size: cover
        background-repeat: no-repeat
        @include media-breakpoint-down($lg)
            padding-top: 14%
            padding-left: 9.6%
            padding-bottom: 14%
            min-height: initial
        @media print
            padding-top: 0
            padding-bottom: .3cm
h3
    color: #ffffff
    max-width: 12em
    @media print
        max-width: initial
// img
//     width: 100%
//     height: auto
//     margin-left: auto
//     display: block
//     position: relative

</style>
